import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconTemplates = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M36.544 1.953c-.3.047-.792.175-1.095.285-1.833.664-3.21 2.46-3.51 4.578-.053.376-.068 7.183-.054 25.6l.019 25.088.139.486c.584 2.045 2.05 3.423 4.231 3.98l.558.142H53.6l.576-.151c1.13-.298 1.847-.728 2.672-1.604.388-.413.558-.662.842-1.237.204-.412.418-.966.501-1.296l.145-.576V6.432l-.18-.576c-.272-.868-.639-1.508-1.218-2.122-.798-.846-1.644-1.342-2.857-1.677l-.609-.168-8.192-.011c-6.587-.01-8.299.005-8.736.075m-22.203.06c-.878.167-1.785.739-2.338 1.475-.308.41-5.512 10.809-5.815 11.618-.125.336-.294.897-.374 1.248l-.147.638-.022 18.144c-.016 13.538-.003 18.282.053 18.688.203 1.485.693 2.805 1.49 4.013 1.622 2.46 4.191 3.987 7.143 4.247 2.715.24 5.359-.715 7.355-2.654a9.54 9.54 0 0 0 2.6-4.449c.3-1.154.291-.606.291-19.547 0-19.188.016-18.238-.324-19.576-.209-.826-.474-1.392-3.275-6.989l-2.625-5.246-.52-.517c-.55-.547-1.18-.921-1.769-1.051-.531-.117-1.232-.134-1.723-.041m22.594 3.97c-.357.113-.662.409-.85.825-.148.326-.15.348-.167 3.318l-.019 2.99 3.635.018 3.634.018.312.16c.375.19.768.572.956.925.114.212.139.368.14.867 0 .52-.023.652-.157.916-.193.377-.615.776-1.016.962-.294.135-.365.138-3.899.157l-3.6.019v7.222l3.664.018 3.664.018.275.147c1.191.636 1.477 2.16.593 3.166-.112.128-.38.32-.594.428l-.39.195h-7.212v7.296h3.6l3.6.001.324.151c.464.216.762.503.985.95.26.52.276 1.187.04 1.693-.181.389-.562.79-.946.994l-.275.147-3.664.018-3.664.018v7.222l3.6.02c3.534.018 3.605.02 3.9.156.4.186.822.585 1.014.962.135.264.158.395.157.916 0 .499-.025.655-.139.867-.188.354-.581.734-.956.926l-.312.159-3.632.018-3.632.018v2.958c0 1.867.025 3.047.068 3.2.083.298.389.655.694.81.524.266.609.268 8.742.248l7.808-.02.304-.15c.352-.173.523-.388.693-.874.12-.341.123-.871.123-25.14 0-18.792-.018-24.846-.075-25.01-.127-.367-.32-.567-.754-.781l-.416-.205-7.937-.012c-6.589-.01-7.986.002-8.219.075M12.56 11.232l-2.512 5.024h5.024c3.301 0 5.024-.022 5.024-.064 0-.084-4.95-9.984-4.992-9.984-.018 0-1.163 2.26-2.544 5.024M9.664 33.28v12.992h10.88V20.288H9.664zm.014 18.704c.024 1.703.03 1.757.203 2.288.932 2.84 3.904 4.438 6.725 3.616a5.56 5.56 0 0 0 3.388-2.828c.457-.924.504-1.199.534-3.108l.027-1.712H9.653z" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconTemplates.displayName = 'IconTemplates';